export const LIST_CHATBOT_OPTIONS = 'LIST_CHATBOT_OPTIONS';
export const LIST_CHATBOT_OPTIONS_LOADING = 'LIST_CHATBOT_OPTIONS_LOADING';
